export default {
    company_agency: "Store",
    document: "CI",
    no_company_agency_found: "No stores found",
    project_name: "Academia Inca",
}